(function () {
  const BAR_CLASS = "luveGalleryBar";
  const FILL_CLASS = "luveGalleryBar__fill";

  function ensureBar(container) {
    if (!container) return null;
    if (container.querySelector("." + BAR_CLASS)) return container.querySelector("." + BAR_CLASS);

    const bar = document.createElement("div");
    bar.className = BAR_CLASS;
    bar.innerHTML = `<span class="${FILL_CLASS}"></span>`;
    container.appendChild(bar);
    return bar;
  }

  function setProgress(container, currentIndex, total) {
    const bar = container.querySelector("." + BAR_CLASS);
    if (!bar) return;
    const fill = bar.querySelector("." + FILL_CLASS);
    if (!fill) return;

    const safeTotal = Math.max(1, total);
    const safeIndex = Math.min(Math.max(0, currentIndex), safeTotal - 1);

    const pct = ((safeIndex + 1) / safeTotal) * 100;
    fill.style.width = pct + "%";
  }

  // ✅ Caso A: Swiper
  function initSwiperProgress(root) {
    // Busca un swiper dentro del root
    const swiperEl =
      root.querySelector(".swiper") ||
      root.querySelector(".swiper-container") ||
      root.querySelector("[data-swiper]");

    if (!swiperEl) return false;

    // Intento de obtener instancia (varía por theme)
    const swiper =
      swiperEl.swiper ||
      swiperEl.__swiper ||
      (window.Swiper && window.Swiper.instances && window.Swiper.instances[0]) ||
      null;

    // Si todavía no existe la instancia, reintenta un poco
    if (!swiper) return false;

    // dónde ponemos la barra: debajo del carrusel
    ensureBar(root);

    const total = swiper.slides?.length || 1;
    setProgress(root, swiper.activeIndex || 0, total);

    swiper.on("slideChange", function () {
      const totalNow = swiper.slides?.length || total;
      setProgress(root, swiper.activeIndex || 0, totalNow);
    });

    swiper.on("slidesLengthChange", function () {
      const totalNow = swiper.slides?.length || total;
      setProgress(root, swiper.activeIndex || 0, totalNow);
    });

    return true;
  }

  // ✅ Caso B: Carrusel por scroll horizontal (overflow-x)
  function initScrollProgress(root) {
    // Busca un contenedor scrolleable típico
    const scroller =
      root.querySelector('[data-media-scroll]') ||
      root.querySelector(".product__media-list") ||
      root.querySelector(".product-media") ||
      root.querySelector('[role="list"]');

    if (!scroller) return false;

    // Asegura barra
    ensureBar(root);

    // total items (images)
    const items = scroller.querySelectorAll("li, .media, .product__media-item, [data-media-id]");
    const total = Math.max(1, items.length);

    function calcIndexByScroll() {
      // aproximación: avance por “pantallas”
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 0) return 0;
      const ratio = scroller.scrollLeft / maxScroll;
      const idx = Math.round(ratio * (total - 1));
      return idx;
    }

    setProgress(root, calcIndexByScroll(), total);

    scroller.addEventListener(
      "scroll",
      () => setProgress(root, calcIndexByScroll(), total),
      { passive: true }
    );

    window.addEventListener(
      "resize",
      () => setProgress(root, calcIndexByScroll(), total),
      { passive: true }
    );

    return true;
  }

  function init() {
    // 👉 Acá apuntamos al “bloque” del media gallery del producto.
    // Probamos varios selectores comunes para Shrine / Shopify themes.
    const roots = [
      document.querySelector(".product__media-wrapper"),
      document.querySelector(".product__media"),
      document.querySelector(".product-media"),
      document.querySelector("[data-product-media]"),
      document.querySelector(".product__gallery"),
      document.querySelector(".media-gallery")
    ].filter(Boolean);

    if (!roots.length) return;

    roots.forEach((root) => {
      // Evita duplicar
      if (root.dataset.luveProgressInit === "1") return;

      // Intentamos Swiper primero
      const okSwiper = initSwiperProgress(root);

      // Si no era swiper, probamos scroll
      const okScroll = okSwiper ? true : initScrollProgress(root);

      if (okScroll) root.dataset.luveProgressInit = "1";
    });
  }

  // Arranque + reintento por si el theme carga tarde
  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("load", init);

  // Por si Shopify re-renderiza secciones (theme editor / ajax)
  document.addEventListener("shopify:section:load", init);
})();
